import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetSmsTemplatesQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_SMS_TEMPLATES],
    queryFn: () => api.get(API_ROUTES.GET_SMS_TEMPLATES),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useGetSmsTemplateByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_SMS_TEMPLATE_BY_ID, id],
    queryFn: () =>
      api.get(`${API_ROUTES.GET_SMS_TEMPLATE_BY_ID.replace(":id", id)}`),
    enabled: !!id,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useCreateSmsTemplateMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.post(API_ROUTES.CREATE_SMS_TEMPLATE, data),
      onSuccess: () => {
        showToast("success", "SMS template created successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_SMS_TEMPLATES);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useUpdateSmsTemplateMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.put(
          `${API_ROUTES.UPDATE_SMS_TEMPLATE.replace(":id", data?.id)}`,
          data
        ),
      onSuccess: () => {
        showToast("success", "SMS template updated successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries([API_ROUTES.GET_SMS_TEMPLATES]);
        queryClient.invalidateQueries([API_ROUTES.GET_SMS_TEMPLATE_BY_ID]);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useDeleteSmsTemplateMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) =>
        api.delete(`${API_ROUTES.DELETE_SMS_TEMPLATE.replace(":id", id)}`),
      onSuccess: () => {
        showToast("success", "SMS template deleted successfully");
      },
      onSettled: () => {
        queryClient.invalidateQueries([API_ROUTES.GET_SMS_TEMPLATES]);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};